import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { WEIGHT_PATH, addWeight } from '../../api/weightApi'
import { addWeightAction } from '../../redux/feature/weightSlice'

const WeightSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newWeight, setNewWeight] = useState({
        code: "",
        name: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${WEIGHT_PATH}`, true)

    const onClickSubmit = () => {
        addWeight(newWeight)
            .then(res => {
                dispatch(addWeightAction(res.data))
                closeTab()
                toast.success('Gramaj kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Gramaj</label>
                <Input
                    label='Gramaj Kodu'
                    name='code'
                    placeholder='Gramaj kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewWeight, setErrors)}
                />
                <Input
                    label='Gramaj Adı'
                    name='name'
                    placeholder='Gramaj adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewWeight, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewWeight, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default WeightSubmitPage